// extracted by mini-css-extract-plugin
module.exports = {"Link":"styles_Link__mwEVw"};